<template>
  <div class="py-5 text-center abbv-wrapper">
    <div class="container text-center">
      <div v-html="$t('Footer.legalrules')" class="abbrev-terms"></div>
      <div class="abbrev-terms mt-2">© {{ new Date().getFullYear() }} {{ $t('Footer.FtWkkc') }} <br>© {{ new
        Date().getFullYear() }} {{
          $t('Footer.FtMicrosoft') }}</div>
    </div>
  </div>
  <footer class="py-4">
    <div class="container-fluid px-4 py-0">
      <div class="row align-items-center">
        <div class="col-md-9 text-center text-md-start">
          <ul class="list-inline mb-0 footer-links" id="footer-nav">
            <li class="list-inline-item"><router-link :to="{ name: 'Home' }">{{ $t('Footer.Home') }}</router-link></li>
            <li class="list-inline-item"><router-link :to="{ name: 'ReceiptTroubleshooting' }">{{
              $t('Footer.ReceiptTroubleshooting') }}</router-link></li>
            <li class="list-inline-item"><a href="http://snipp.us/!cuYZD" target="_blank"
                :aria-label="$t('Footer.T&CLink') + ' (opens in a new tab)'">{{ $t('Footer.T&CLink') }}</a>
            </li>
            <li class="list-inline-item"><router-link :to="{ name: 'FAQ' }">{{
              $t('Footer.FAQlink') }}</router-link></li>
            <li class="list-inline-item"><a href="http://snipp.us/!csN7Y" target="_blank"
                :aria-label="$t('Footer.ContactUsLink') + ' (opens in a new tab)'">{{ $t('Footer.ContactUsLink') }}</a>
            </li>
            <li class="list-inline-item"><a nohref="nohref" class="track ot-sdk-show-settings"
                aria-label="Cookie Preferences">{{
                  $t('Footer.CookiePreference') }}</a></li>
            <li class="list-inline-item"><a href="http://snipp.us/!csNwP" target="_blank"
                :aria-label="$t('Footer.PrivayPolicyLink') + ' (opens in a new tab)'">{{ $t('Footer.PrivayPolicyLink')
                }}</a></li>
            <li class="list-inline-item"><a href="http://snipp.us/!csNwE" target="_blank"
                :aria-label="$t('Footer.USPrivacyLink') + ' (opens in a new tab)'">{{ $t('Footer.USPrivacyLink') }}</a>
            </li>
            <li class="list-inline-item"><a href="http://snipp.us/!csNwD" target="_blank"
                :aria-label="$t('Footer.TermsOfUseLink') + ' (opens in a new tab)'">{{ $t('Footer.TermsOfUseLink')
                }}</a></li>
            <li class="list-inline-item"><a href="http://snipp.us/!csNwQ" target="_blank"
                :aria-label="$t('Footer.DoNotSellLink') + ' (opens in a new tab)'">{{ $t('Footer.DoNotSellLink') }}</a>
            </li>
            <li class="list-inline-item"><a href="http://snipp.us/!csNwR" target="_blank"
                :aria-label="$t('Footer.AccessibilityLink') + ' (opens in a new tab)'">{{ $t('Footer.AccessibilityLink')
                }}</a></li>
          </ul>
          <p class="mt-4 mt-sm-1 mb-0 copyright-text">
            © {{ new Date().getFullYear() }} {{ $t('Footer.FtWkkc') }} © {{ new Date().getFullYear() }} {{
              $t('Footer.FtMicrosoft') }}. {{ $t('Footer.copyrighttext') }}
          </p>
        </div>
        <div class="col-md-3 text-center text-md-end mt-3 mt-md-0 pe-5">
          <div class="footer-social-nav">
            <ul class="list-inline m-0">
              <li class="fw-bold footer-links me-2 list-inline-item">{{ $t('Footer.FollowUs') }}</li>
              <li class="list-inline-item">
                <a href="https://www.instagram.com/kelloggsus/?hl=en" class="ig-link social-icon"
                  aria-label="Instagram (opens in a new tab)" target="_blank">
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  /* mounted() {
     // // Dynamically fetch the translated modelHash
     const modelHash = this.$t('YounetmodelHash');
     const modelImgurl = this.$t('YounetmodelIMg');
     const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}&bottom=90`;
 
     // // Dynamically create the script element
     const script = document.createElement('script');
     script.type = 'module';
     script.src = scriptUrl;
 
     // // Append the script to the body
     document.body.appendChild(script);
   },*/
};
</script>